import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { editorPicks } from '@/mocks/home';

export default function EditorPickSection() {
  const { t } = useTranslation();
  const [current, setCurrent] = useState(0);

  const pick = editorPicks[current];

  return (
    <section className="relative w-full bg-background-50 py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-8 md:mb-10">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-1 h-6 md:h-8 rounded-full bg-accent-500"></div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              {t('home:section_editor_title')}
            </h2>
          </div>
          <p className="text-sm text-foreground-500 ml-4 md:ml-5">{t('home:section_editor_quote')}</p>
        </div>

        <div className="relative bg-foreground-950 rounded-[28px] md:rounded-[36px] overflow-visible">
          <div className="flex flex-col md:flex-row">
            <div className="relative md:w-[320px] lg:w-[380px] flex-shrink-0 -mt-10 md:-mt-14 md:-ml-8 mx-auto md:mx-0">
              <div className="w-[180px] h-[220px] md:w-[260px] md:h-[320px] rounded-2xl md:rounded-3xl overflow-hidden">
                <img
                  src={pick.avatar}
                  alt={pick.editor}
                  title={`${pick.editor} - ${pick.title}`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            <div className="flex-1 px-5 md:px-10 py-6 md:py-12 flex flex-col justify-center">
              <span className="text-6xl md:text-8xl text-secondary-400/30 font-serif leading-none mb-4 md:mb-6 select-none">
                &ldquo;
              </span>
              <blockquote className="text-base md:text-lg lg:text-xl text-background-50 leading-relaxed mb-6 md:mb-8 max-w-[600px]">
                {pick.quote}
              </blockquote>
              <div className="flex flex-col sm:flex-row sm:items-center gap-4 md:gap-6">
                <div>
                  <p className="text-sm md:text-base font-semibold text-background-50">{pick.editor}</p>
                  <p className="text-xs md:text-sm text-foreground-500 mt-0.5">{pick.title}</p>
                </div>
                <Link
                  to={`/article/1`}
                  className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-accent-500 text-foreground-950 font-medium text-sm hover:bg-accent-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  {pick.comicTitle}
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-up-line text-sm"></i>
                  </span>
                </Link>
              </div>

              <div className="flex items-center gap-2 mt-6 md:mt-8">
                {editorPicks.map((_, idx) => (
                  <button
                    key={idx}
                    onClick={() => setCurrent(idx)}
                    className={`w-2 h-2 md:w-2.5 md:h-2.5 rounded-full transition-all duration-300 cursor-pointer ${
                      idx === current
                        ? 'bg-accent-500 w-6 md:w-8'
                        : 'bg-foreground-600 hover:bg-foreground-500'
                    }`}
                    aria-label={`第${idx + 1}条编辑推荐`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}